export default "__VITE_ASSET__DwyDsrs6__"